import { Activity, Check, Loader2 } from "lucide-react";

const MissionRow = ({ m }) => (
  <div className="flex items-start gap-2.5 rounded-xl bg-[#141414] p-3" data-testid={`aria-mission-${m.id}`}>
    <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg ${m.state === "running" ? "bg-[rgba(79,142,247,0.14)] text-[#7FAEF9]" : "bg-[rgba(34,197,94,0.16)] text-[#4ADE80]"}`}>
      {m.state === "running" ? <Loader2 size={12} className="animate-spin" /> : <Check size={12} />}
    </span>
    <div className="min-w-0 flex-1">
      <div className="line-clamp-2 text-[12px] font-medium text-white">{m.label}</div>
      {m.detail && <div className="mt-0.5 text-[10.5px] text-[#A3A3A3]">{m.detail}</div>}
      <div className={`mt-1 text-[9.5px] uppercase tracking-wide ${m.state === "running" ? "text-[#7FAEF9]" : "text-[#4ADE80]"}`}>
        {m.state === "running" ? "Running…" : "Completed"}
      </div>
    </div>
  </div>
);

export const TasksTab = ({ missions, tasks }) => (
  <div className="flex-1 space-y-2 overflow-y-auto p-3" data-testid="ask-aria-tasks-panel">
    {missions.length === 0 && tasks.length === 0 ? (
      <div className="flex h-full flex-col items-center justify-center px-4 text-center">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[rgba(79,142,247,0.12)] text-[#4F8EF7]"><Activity size={18} /></div>
        <div className="mt-3 text-[12.5px] font-medium text-white">Aria is standing by</div>
        <div className="mt-1 text-[11px] text-[#6b6b6b]">Give Aria a command — you'll see exactly what it's doing here in real time.</div>
      </div>
    ) : (
      <>
        {missions.length > 0 && (
          <div className="px-1 text-[10px] font-semibold uppercase tracking-wider text-[#6b6b6b]">This session</div>
        )}
        {missions.map((m) => <MissionRow key={m.id} m={m} />)}
        {tasks.length > 0 && (
          <div className="px-1 pt-2 text-[10px] font-semibold uppercase tracking-wider text-[#6b6b6b]">Task queue</div>
        )}
        {tasks.slice(0, 12).map((t) => (
          <div key={t.id} className="flex items-start gap-2.5 rounded-xl bg-[#141414] p-3" data-testid={`aria-task-${t.id}`}>
            <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg ${t.status === "open" ? "bg-[rgba(245,158,11,0.15)] text-[#FBBF24]" : "bg-[rgba(34,197,94,0.16)] text-[#4ADE80]"}`}>
              {t.status === "open" ? <Activity size={12} /> : <Check size={12} />}
            </span>
            <div className="min-w-0 flex-1">
              <div className="line-clamp-2 text-[12px] font-medium text-white">{t.title}</div>
              {t.detail && <div className="mt-0.5 line-clamp-2 text-[10.5px] text-[#A3A3A3]">{t.detail}</div>}
              <div className={`mt-1 text-[9.5px] uppercase tracking-wide ${t.status === "open" ? "text-[#FBBF24]" : "text-[#4ADE80]"}`}>{t.status}</div>
            </div>
          </div>
        ))}
      </>
    )}
  </div>
);
